class MixMatchLink extends HTMLElement {
  connectedCallback() {
    this.shell = this.querySelector('.mmf__shell');
    this.productInfo = this.closest('[product-info]') || document;
    this.buttonUrl = this.dataset.buttonUrl || '';

    this.handleUpdate = this.handleUpdate.bind(this);

    this.productInfo.addEventListener('change', this.handleUpdate);
    this.productInfo.addEventListener('input', this.handleUpdate);
    document.addEventListener('variant:change', this.handleUpdate, true);

    this.observer = new MutationObserver(() => {
      window.requestAnimationFrame(() => this.handleUpdate());
    });

    this.observer.observe(this.productInfo, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['checked', 'selected', 'value']
    });

    this.handleUpdate();
  }

  disconnectedCallback() {
    if (this.productInfo) {
      this.productInfo.removeEventListener('change', this.handleUpdate);
      this.productInfo.removeEventListener('input', this.handleUpdate);
    }
    document.removeEventListener('variant:change', this.handleUpdate, true);

    if (this.observer) {
      this.observer.disconnect();
    }
  }

  handleUpdate() {
    if (!this.shell) return;

    const shouldShow = this.shouldShowBlock() && !!this.buttonUrl;
    this.shell.hidden = !shouldShow;
  }

  shouldShowBlock() {
    const primaryValue = this.getSelectedOptionValue(['size', 'serving']);
    const secondaryValue = this.getSelectedOptionValue(['size options', 'size option']);

    const primaryNormal = this.normalize(primaryValue);
    const secondaryNormal = this.normalize(secondaryValue);

    const bulkGroup =
      primaryNormal.includes('regular sizes') ||
      primaryNormal.includes('kilogram');

    let sizeInKg = this.extractKgValue(secondaryNormal);

    if (!sizeInKg) {
      sizeInKg = this.extractKgValue(primaryNormal);
    }

    return bulkGroup && sizeInKg > 1;
  }

  getSelectedOptionValue(optionNames) {
    for (const optionName of optionNames) {
      const container = this.productInfo.querySelector(
        `[product-variant-option][data-option-name="${optionName}"]`
      );

      if (!container) continue;

      const checkedInput = container.querySelector('input[type="radio"]:checked');
      if (checkedInput) return checkedInput.value || '';

      const select = container.querySelector('select');
      if (select) return select.value || '';

      const currentValue = container.querySelector('[product-variant-option-value]');
      if (currentValue) return currentValue.textContent.trim();
    }

    return '';
  }

  extractKgValue(value) {
    if (!value) return 0;

    const kgMatch = value.match(/(\d+(?:\.\d+)?)\s*kg/);
    if (kgMatch) return parseFloat(kgMatch[1]);

    const gMatch = value.match(/(\d+(?:\.\d+)?)\s*g/);
    if (gMatch) return parseFloat(gMatch[1]) / 1000;

    return 0;
  }

  normalize(value) {
    return (value || '').toString().trim().toLowerCase();
  }
}

if (!customElements.get('mix-match-link')) {
  customElements.define('mix-match-link', MixMatchLink);
}